import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { BRAND, brandAlpha } from '../../theme/brandTokens';

export const membershipOptionLabelSx = {
  mx: 0,
  width: '100%',
  alignItems: 'center',
  '& .MuiFormControlLabel-label': {
    flex: 1,
    minWidth: 0,
    width: '100%',
  },
};

const tagSxByVariant = {
  subscribed: {
    bgcolor: 'rgba(46, 125, 50, 0.12)',
    color: '#2e7d32',
    fontWeight: 700,
  },
  enroll: {
    bgcolor: brandAlpha('accent', 0.14),
    color: BRAND.accentText,
    fontWeight: 700,
  },
};

const MembershipBookingOptionLabel = ({ name, tag, variant }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1,
      width: '100%',
      minWidth: 0,
    }}
  >
    <Typography component="span" noWrap sx={{ fontWeight: 600, color: BRAND.text }}>
      {name}
    </Typography>
    {tag ? (
      <Chip
        size="small"
        label={tag}
        sx={{ flexShrink: 0, height: 22, ...tagSxByVariant[variant] }}
      />
    ) : null}
  </Box>
);

export default MembershipBookingOptionLabel;
